/**
 * Floating Video Module
 * @module floatingVideo
 */

import $ from 'jquery';
import './custom-video-player';
import registerJQueryPlugin from '../../lib/register-jquery-plugin';
import mergeOptions from '../../lib/merge-options';

// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'floatingVideo';
export const DEFAULTS = {
  // filled: 0,
  videoMuted: true,
};

const returnVideoContainerHTML = (videoUrl, videoPosterUrl) => $(`
  <div id="js-floating-video-container" class="floating-video__container">
    <button class="floating-video__close js-floating-video__close" type="button">
        <span class="icon icon--x icon--sm">
          <svg viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
            <path
              d="M9.06 8l2.72-2.72A.75.75 0 0 0 10.72 4.22L8 6.94 5.28 4.22A.75.75 0 0 0 4.22 5.28L6.94 8l-2.72 2.72A.75.75 0 1 0 5.28 11.78L8 9.06l2.72 2.72a.75.75 0 0 0 1.061-1.061z">
            </path>
          </svg>
          <div class="u-screen-reader">Close Modal</div>
        </span>
    </button>
    <video class="u-full-width" poster="${videoPosterUrl}" playsinline="playsinline" loop>
      <source src="${videoUrl}" type="video/mp4">
    </video>
  </div>
`);

/**
 * Sets the calculated attributes to each of the <circle> elements in the
 * progress ring module
 * @param  {jQuery} $el - progress ring element
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const showVideo = ($el, options) => {
  const videoUrl = $el.data('videoUrl');
  const videoPosterUrl = $el.data('videoPosterUrl');
  const $floatingContainer = returnVideoContainerHTML(videoUrl, videoPosterUrl);
  const $video = $floatingContainer.find('video');
  const $closeButton = $floatingContainer.find('.js-floating-video__close');

  // remove existing player if one already exists
  $('#js-floating-video-container').remove();
  $('body').append($floatingContainer);


  // Close Button Listener
  $closeButton.on('click', function () {
    $floatingContainer.remove();
  });

  $video.customVideoPlayer(options);
  makeDraggable($floatingContainer[0]);
}

const makeDraggable = (container) => {
  let offsetX, offsetY;
  let startX, startY;
  let isDragging = false;
  let hasMoved = false;
  const DRAG_THRESHOLD = 5;

  const getEventCoords = (e) => {
    if (e.touches && e.touches.length) {
      return { x: e.touches[0].clientX, y: e.touches[0].clientY };
    } else {
      return { x: e.clientX, y: e.clientY };
    }
  };

  const onStart = (e) => {
    // Skip if it's a click on a control button
    if (e.target.closest('.custom-video__play .icon, .custom-video__mute, .custom-video__fullscreen, .custom-video__progress-bar, .floating-video__close')) {
      return;
    }

    const { x, y } = getEventCoords(e);
    const rect = container.getBoundingClientRect();
    offsetX = x - rect.left;
    offsetY = y - rect.top;
    startX = x;
    startY = y;
    hasMoved = false;
    isDragging = false;

    // Add event listeners directly to the document for better capture
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onEnd);
  };

  const onMove = (e) => {
    const { x, y } = getEventCoords(e);
    const dx = x - startX;
    const dy = y - startY;
    const distance = Math.sqrt(dx * dx + dy * dy);

    if (!hasMoved && distance > DRAG_THRESHOLD) {
      hasMoved = true;
      isDragging = true;

      // Add a dragging class to the container when dragging starts
      container.classList.add('is-dragging');
    }

    if (isDragging) {
      // Only prevent default when actually dragging
      e.preventDefault();

      const left = x - offsetX;
      const top = y - offsetY;

      container.style.top = `${top}px`;
      container.style.left = `${left}px`;
      container.style.right = 'auto';
      container.style.bottom = 'auto';
    }
  };

  const onEnd = () => {
    document.removeEventListener('mousemove', onMove);
    document.removeEventListener('mouseup', onEnd);
    document.removeEventListener('touchmove', onMove);
    document.removeEventListener('touchend', onEnd);

    if (isDragging) {
      dockToNearestCorner(container);
      container.classList.remove('is-dragging');
    }

    requestAnimationFrame(() => {
      isDragging = false;
      hasMoved = false;
    });
  };

  container.addEventListener('mousedown', onStart);
  container.addEventListener('touchstart', onStart);

  container.addEventListener(
      'click',
      (e) => {
        if (isDragging || hasMoved) {
          e.stopImmediatePropagation();
          e.preventDefault();
        }
      },
      true
  );
};



const dockToNearestCorner = container => {
  const padding = 40;
  const winW = window.innerWidth;
  const winH = window.innerHeight;
  const rect = container.getBoundingClientRect();

  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;

  const dockLeft = centerX < winW / 2;
  const dockTop = centerY < winH / 2;

  container.style.top = dockTop ? `${padding}px` : 'auto';
  container.style.bottom = dockTop ? 'auto' : `${padding}px`;
  container.style.left = dockLeft ? `${padding}px` : 'auto';
  container.style.right = dockLeft ? 'auto' : `${padding}px`;
}

/**
 * Initializes floatingVideo
 * @param {HTMLElement} el - thumbnail
 * @param {Object} options - Options used for wiring up the floatingVideo
 * @see DEFAULTS
 */
export default function floatingVideo(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);

  $el.on('click', () => {
    showVideo($el, opts);
  })
  
  return {
    // rerender: (filled, pending) => rerender($el, filled, pending, opts),
  };
}
registerJQueryPlugin(PLUGIN_NAME, floatingVideo);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/floating-video.js